export default (store) => {
    const ability = store.getters.ability;

    ability.update(store.state.accessRules);

    return store.subscribe((mutation) => {
        switch (mutation.type) {
            case 'UPDATE_USER_ACCESS':
                ability.update(mutation.payload);
                break;
            case 'destroySession':
                ability.update([
                    {
                        actions: 'read',
                        subject: 'loginpage',
                    },
                ]);
                break;
        }
    });
}
